module.exports = require("@swa-ui/persistence/persistence");